(function () {
    angular.module('imnApp').controller('OltDetailController', OltDetailController);

    OltDetailController.$inject = [
        '$scope',
        '$filter',
        'OltService',
        'RequestService',
        'ConsoleWebService',
        'OltData',
        'SystemConfigService'
    ];

    function OltDetailController(
            $scope,
            $filter,
            OltService,
            RequestService,
            ConsoleWebService,
            OltData,
            SystemConfigService
            ) {
        var vm = this;

        vm.requestRunning = {
            ports: false,
            status: false,
            config: false
        };

        var OLT_MODEL_INTELBRAS = 'Intelbras8820i';
        var MAX_UPLOAD_FILES_SIZE_BYTES = 209715200; // 200MB
        var INVALID_FILE_NAME_INTELBRAS_REGEX = /[^a-zA-Z0-9._\-]/; // Special
        // characters
        var INVALID_FILE_NAME_ZHONE_REGEX = /[^a-zA-Z0-9._\- ]/; // Special
        // characters
        // and empty
        // spaces

        // Get the selected OLT data from shared service
        vm.data = OltData;
        var oltId = OltData.detail.id;

        // Menu actions
        vm.restartOlt = restartOlt;
        vm.uploadFilesToOlt = uploadFilesToOlt;
        vm.uploadFilesTftp = uploadFilesTftp;
        vm.restore = restore;
        vm.updateFirmware = updateFirmware;
        vm.backup = backup;
        vm.deleteOlt = deleteOlt;
        vm.editOlt = editOlt;
        vm.accessCode = accessCode;
        vm.setGtpCpeMgrOlt = setGtpCpeMgrOlt;
        // Apply datetime action
        vm.setDateOlt = setDateOlt;
        vm.abreModalAlarmShow = abreModalAlarmShow;
        vm.setAutoConfig = setAutoConfig;
        vm.isOlt8820i = isOlt8820i;

        // Call of Service Get User
        SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

        // Reset default values and load status data
        if (vm.data.detail) {
            initialize();
        }
        $scope.$on('oltDetailLoad', initialize);

        // Update the OLT data when it is edited
        $scope.$on('oltUpdateSuccess', updateOltData);

        // Action functions
        function accessCode() {
            ConsoleWebService.consoleWebModalConstructor(OltData.detail.id);
        }

        function restartOlt() {
            var dataAction = {
                action: 'restart',
                methodService: 'restartOlts'
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function uploadFilesToOlt() {
            if (vm.files.length > 0) {
                if (validateFiles(vm.files)) {
                    var data = {
                        oltId: OltData.detail.id,
                        files: vm.files
                    };
                    OltService.uploadFilesToOlt(data).then(successUpload).catch(errorUpload);
                } else {
                    errorUpload({status: 400, config: {}});
                }
            }
        }

        function uploadFilesTftp() {
            OltService.uploadFilesTftpModalConstructor(OltData.detail.id);
        }

        function validateFiles(files) {
            var invalidFileNameRegex =
                    vm.data.detail.model === OLT_MODEL_INTELBRAS
                    ? INVALID_FILE_NAME_INTELBRAS_REGEX
                    : INVALID_FILE_NAME_ZHONE_REGEX;
            var totalFilesSize = 0;
            for (var i = 0; i < files.length; ++i) {
                var file = vm.files[i];
                var regexMatch = file.name.match(invalidFileNameRegex);
                if (regexMatch !== null) {
                    return false;
                }
                totalFilesSize += file.size;
            }
            return totalFilesSize <= MAX_UPLOAD_FILES_SIZE_BYTES;

        }

        function restore() {
            OltService.optionRestoreModalConstructor();
        }

        function backup() {
            var dataAction = {
                action: 'backup',
                methodService: 'backupOlts'
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function deleteOlt() {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteOlts',
                methodExtra: function (oltList) {
                    OltData.removeOlts(oltList);
                }
            };
            OltService.confirmationOltModalConstructor([OltData.detail], dataAction);
        }

        function editOlt() {
            OltService.editOltModalConstructor(OltData.detail.id, $scope);
        }

        function updateFirmware() {
            OltService.updateFirmwareOnuModalConstructor(OltData.detail.id);
        }

        function setGtpCpeMgrOlt() {
            OltService.gtpCpeMgrModalConstructor(OltData.detail.id, $scope);
        }

        function setDateOlt() {
            var data = {
                date: $filter('date')(vm.datepicker.selected, 'yyyy-MM-dd'),
                time: vm.time.hour + ':' + vm.time.minute
            };
            OltService.updateOltDateTime(OltData.detail.id, data).then(successDate).catch(errorDate);
        }

        // Reset default configuration of status information and call status
        // requests
        function initialize() {
            vm.statusDisabled = true;

            vm.data.detail.model = vm.data.arrayOlts.find(function (olt) {
                return olt.id === vm.data.detail.id;
            }).model;

            vm.statusOlt = {
                uptime: '--h --min',
                temperature: '-- °C',
                ip: '--.--.--.--',
                coolerStatus: false,
                cardMemoryStatus: false,
                softwareVersion: '--.--.--'
            };

            /* eslint-disable angular/controller-as-vm */
            vm.datepicker = {
                toggle: function () {
                    this.opened = !this.opened;
                },
                opened: false,
                format: 'dd-MMMM-yyyy',
                selected: '--',
                options: {
                    formatYear: 'yy',
                    minDate: new Date(2000, 0, 1),
                    startingDay: 1,
                    showWeeks: false,
                    formatMonth: 'MMM'
                }
            };

            vm.time = {
                hours: listHours(),
                minutes: listMinutes(),
                hour: '--',
                minute: '--'
            };
            /* eslint-enable angular/controller-as-vm */

            cancelRequests();
            getOltStatus();

            oltId = OltData.detail.id;
        }

        // Requests
        function getOltStatus() {
            if (vm.data.detail.onLine) {
                vm.requestRunning.ports = true;
                OltService.getAllPorts(OltData.detail.id).then(successPorts);
                vm.requestRunning.status = true;
                OltService.getOltDetail(OltData.detail.id).then(successDetail).catch(errorDetail);
            }
        }

        // Cancel requests
        $scope.$on('$destroy', cancelRequests);
        function cancelRequests() {
            RequestService.cancelRequests(['ports/' + oltId, 'olts/' + oltId + '/details', 'history/' + oltId]);
        }

        // Request callbacks
        function successPorts(data) {
            for (var portType in data) {
                data[portType].forEach(function (item) {
                    item.mostCriticalAlarm = item.mostCriticalAlarm.toLowerCase();
                    item.status = item.status.toLowerCase().replace('_', '');
                });
            }
            vm.ports = data;
            vm.requestRunning.ports = false;
        }

        function successDetail(data) {
            vm.statusOlt = data;
            vm.datepicker.selected = new Date(data.date + ' 00:00:00');
            vm.statusDisabled = false;

            var time = data.time.split(':');
            vm.time.hour = time[0];
            vm.time.minute = time[1];
            vm.requestRunning.status = false;

            vm.automatedProvisioning = data.automatedProvisioning;
            vm.autoService = data.autoService;
        }

        function errorDetail(response) {
            OltService.errorModalConstructor(response, 'detail');
            vm.requestRunning.status = false;
        }

        function successDate(data) {
            OltService.successModalConstructor('setDateTime');
        }

        function errorDate(response) {
            OltService.errorModalConstructor(response, 'setDateTime');
        }

        function successUpload(data) {
            var isMultiple = vm.files.length > 1;
            OltService.successModalConstructor('loadFiles', isMultiple);
        }

        function errorUpload(response) {
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function updateOltData(event, data) {
            vm.statusOlt.ip = data.ip;
            OltData.detail.name = data.name;
        }

        // Helper functions
        function listHours() {
            var hours = [];
            for (var i = 0; i < 24; i++) {
                hours.push((i < 10 ? '0' : '') + i);
            }
            return hours;
        }

        function listMinutes() {
            var minutes = [];
            for (var i = 0; i < 60; i++) {
                minutes.push((i < 10 ? '0' : '') + i);
            }
            return minutes;
        }

        function successGet(data) {
            vm.requestRunning.config = false;

            if (data) {
                vm.fromSIG = data.fromSig;
            }
        }

        function errorGet(response) {
            vm.requestRunning.config = false;
            SystemConfigService.errorModalConstructor(response, 'get');
        }

        function abreModalAlarmShow() {
            OltService.abreModalAlarmShowConstructor();
        }

        function setAutoConfig() {
            if (vm.autoService && isOlt8820i()) {
                vm.automatedProvisioning = true;
            }

            var data = {
                id: OltData.detail.id,
                automatedProvisioning: vm.automatedProvisioning,
                autoService: vm.autoService
            };

            OltService.setAutoConfig(data);
        }

        function isOlt8820i() {
            // get olt fw version to compare with static fw version without dot separator.
            var oltVersion = vm.statusOlt.softwareVersion;
            var regex = /\D+/gi;
            var oltVersionReplaced = oltVersion.toString().replace(regex, "");
            return OltData.detail.model === 'Intelbras8820i' && parseInt(oltVersionReplaced) >= "262";
        }

    }
})();
